import { ChangeDetectionStrategy, Component, inject, input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationPath } from '@core/navigation/models/application-path.enum';
import { LoginRecoveryFacade } from '@pages/login-recovery-options/facades/login-recovery.facade';
import { LoginRecoveryPath } from '@pages/login-recovery-options/routes/login-recovery-path.enum';
import { TranslatePipe } from '@ngx-translate/core';
import { LargeButtonComponent } from '@kaseya-design-components';
import { LoginRecoveryOptionComponent } from '@pages/login-recovery-options/components/login-recovery-option/login-recovery-option.component';

@Component({
  selector: 'itc-login-recovery-options-list',
  templateUrl: 'login-recovery-options-list.component.html',
  styleUrl: 'login-recovery-options-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LargeButtonComponent, TranslatePipe, LoginRecoveryOptionComponent],
})
export class LoginRecoveryOptionsListComponent implements OnDestroy {
  private readonly loginRecoveryFacade = inject(LoginRecoveryFacade);
  private readonly router = inject(Router);

  readonly loginRecoveryPath = input<LoginRecoveryPath>();
  readonly loginRecoveryOptions = [
    {
      iconClassName: 'fa-regular fa-user',
      labelTranslationKey: 'login.options.forgot-username-link',
      loginRecoveryPath: LoginRecoveryPath.ForgotUsername,
    },
    {
      iconClassName: 'fa-regular fa-building',
      labelTranslationKey: 'login.options.forgot-company-link',
      loginRecoveryPath: LoginRecoveryPath.ForgotCompanyName,
    },
    {
      iconClassName: 'fa-regular fa-key',
      labelTranslationKey: 'login.options.forgot-password-link',
      loginRecoveryPath: LoginRecoveryPath.ForgotPassword,
    },
  ];

  backToLogin(): void {
    this.router.navigateByUrl(ApplicationPath.Login);
  }

  ngOnDestroy(): void {
    this.loginRecoveryFacade.clearState();
  }
}
